import React, { type JSX } from 'react'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { MaxNumberOfRaces } from '../../utils'
import { NextRaceLoading } from '../NextRaceLoading/NextRaceLoading'

export const NextRacesLoading = (): JSX.Element => {
  const races = Array.apply(0, new Array(MaxNumberOfRaces)).map((_, i: number) => (
    <NextRaceLoading key={i} />
  ))

  return <Flex flexDirection='column'>{races}</Flex>
}
